import {FC} from 'react'
import {Card} from 'react-bootstrap'
import bgImage from '../../assets/img/bg.png'
import {truncateText} from 'thesis-and-dissertations/helpers/helper'

type Props = {
  data: any
  isMobile?: boolean
}

const Page3: FC<Props> = ({data, isMobile = false}) => {
  return (
    <Card className='h-100 border-0 bg-light bg-opacity-75 shadow-sm'>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          height: '100%',
        }}
        className={isMobile ? 'p-8' : 'p-14'}
      >
        {data?.pesan_untuk_calon_awardee && (
          <div
            className='mt-2 p-4 shadow rounded-4 border-0'
            style={{
              background: 'linear-gradient(90deg, #F9FAFB 0%, #EFF6FF 100%)',
            }}
          >
            <div className='d-flex justify-content-start'>
              <i className='fa fa-quote-left me-2' style={{color: '#BEDBFF'}}></i>
              <p style={{fontSize: isMobile ? '14px' : '16px', fontWeight: '600'}}>Pesan untuk Calon Awardee LPDP</p>
            </div>

            <div
              className='mt-2'
              style={{
                fontStyle: 'italic',
                letterSpacing: '0%',
                verticalAlign: 'middle',
                fontSize: isMobile ? '13px' : 'inherit'
              }}
            >
              {truncateText(data?.pesan_untuk_calon_awardee, isMobile ? 400 : 600)}
            </div>
          </div>
        )}

        {data?.kenangan_paling_berkesan_studi && (
          <div
            className='mt-4 p-4 shadow rounded-4 border-0'
            style={{
              background: 'linear-gradient(90deg, #F9FAFB 0%, #EFF6FF 100%)',
            }}
          >
            <div className='d-flex justify-content-start'>
              <i className='fa fa-quote-left me-2' style={{color: '#BEDBFF'}}></i>
              <p style={{fontSize: isMobile ? '14px' : '16px', fontWeight: '600'}}>
                Kenangan Paling Berkesan Selama Studi:
              </p>
            </div>

            <div
              className='mt-2'
              style={{
                fontStyle: 'italic',
                letterSpacing: '0%',
                verticalAlign: 'middle',
                fontSize: isMobile ? '13px' : 'inherit'
              }}
            >
              {truncateText(data?.kenangan_paling_berkesan_studi, isMobile ? 400 : 600)}
            </div>
          </div>
        )}
      </div>
    </Card>
  )
}

export default Page3